module.exports = __webpack_public_path__ + "img/user-profile.9de4c439.svg";